var alignmentStyle = {"alignLeft":"hc6ZK","textWrapNowrap":"_1AXLb","alignRight":"E4gVz","alignCenter":"ErLxn","sizeFullWidth":"zDyJp","renderedInTable":"yA9Vg","sizeOriginal":"seg2T","sizeContent":"WnzuO","sizeSmall":"_4-0Xk","sizeSmallCenter":"KxfVj","flex":"dodvy","LEFT":"_7amRb","CENTER":"BU5vi","RIGHT":"E3ttH","AUTO":"_0FQ7p","JUSTIFY":"nZ2s-"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-ea999ed7.js.map
